import { useState } from "react";
import { UserRound } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export function UsernamePrompt() {
  const { setUsername } = useAuth();
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await setUsername(value.trim());
      toast.success("Username set. Welcome to the hearth.");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(Array.isArray(d) ? "Use 3-20 letters, numbers, _ or -" : d || "Could not set username");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form
      onSubmit={submit}
      className="fixed md:static bottom-14 md:bottom-0 inset-x-0 border-t border-zinc-800/60 bg-black/90 backdrop-blur px-4 sm:px-8 py-4 z-20"
      data-testid="username-prompt"
    >
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex items-center gap-2 text-sm text-zinc-300 sm:mr-2">
          <UserRound size={16} className="text-crimson-bright flex-shrink-0" />
          Pick a chat username. Your real name stays hidden.
        </div>
        <div className="flex flex-1 gap-3">
          <input
            data-testid="username-input"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            required
            minLength={3}
            maxLength={20}
            pattern="[A-Za-z0-9_\-]{3,20}"
            title="3-20 letters, numbers, _ or -"
            placeholder="Grimhollow"
            className="tavern-input flex-1 px-4 py-2.5 rounded-sm text-sm"
          />
          <button
            type="submit"
            disabled={saving}
            data-testid="username-save"
            className="btn-crimson px-4 py-2.5 text-xs tracking-[0.3em] uppercase disabled:opacity-50"
          >
            {saving ? "..." : "Save"}
          </button>
        </div>
      </div>
    </form>
  );
}
